import React from "react";
import { Alert } from "@mui/material";
import { BulkUserUploadCard } from "./BulkUserUploadCard";
import { SettingsSection } from "./SettingsSection";

interface BulkUploadTabProps {
  effectiveClientId: string | null;
  isCentralAdmin: boolean;
}

export const BulkUploadTab: React.FC<BulkUploadTabProps> = ({
  effectiveClientId,
  isCentralAdmin,
}) => {
  if (!isCentralAdmin) return null;

  return (
    <SettingsSection>
      {!effectiveClientId ? (
        <Alert severity="info">
          Select a client before using bulk upload.
        </Alert>
      ) : (
        <BulkUserUploadCard
          effectiveClientId={effectiveClientId}
          isCentralAdmin={isCentralAdmin}
        />
      )}
    </SettingsSection>
  );
};
